<!-- Register route: path: '/org/:sub_level/:id/proface-wing', component: ProfaceWingForm -->
<!-- Also embedded (embedded=true) inside ProfaceWingIntro's bottom sheet -->
<template>
    <div class="section pt-0 mt-0" v-if="!embedded">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mal-text mt-1 custom-title">PROFACE COMMUNE</h3>
            <p class="text-center text-primary small mb-0 fw-semibold">PROFESSIONAL WING, WISDOM YOUTH</p>
            <p class="text-center text-muted small mb-0" v-if="zoneName">{{ zoneName }}</p>
        </div>
    </div>

    <div class="section text-center py-4" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="section" v-if="!loading && !canSubmit">
        <p class="text-center text-muted mal-text mb-0">
            യൂത്ത് വിംഗ് മണ്ഡലം അഡ്മിന് മാത്രമേ ഈ ഫോം സമർപ്പിക്കാൻ കഴിയൂ.
        </p>
    </div>

    <form @submit.prevent="submitForm" v-if="!loading">
        <div class="section">
            <div class="card">
                <div class="card-body">
                    <div class="form-group basic" v-for="field in fields" :key="field.key">
                        <label class="label">
                            {{ field.label }}
                            <span class="text-danger" v-if="field.required">*</span>
                        </label>
                        <div class="input-wrapper">
                            <input
                                type="text"
                                class="form-control"
                                :disabled="!canSubmit"
                                v-model="form[field.key]"
                                :placeholder="field.label"
                                autocomplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section" v-if="message">
            <div class="alert alert-danger mb-0">{{ message }}</div>
        </div>

        <div class="section mb-2" v-if="canSubmit">
            <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="submitting">
                <span v-show="submitting" class="spinner-border spinner-border-sm me-1"></span>
                {{ hasSubmitted ? 'വീണ്ടും സമർപ്പിക്കുക' : 'സമർപ്പിക്കുക' }}
            </button>
        </div>
    </form>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "../services/user.service";
import AlertModel from "./layouts/AlertModel.vue";

const FIELDS = [
    { key: "chairman_name", label: "CHAIRMAN (NAME)", required: true },
    { key: "chairman_number", label: "CHAIRMAN (NUMBER)", required: true },
    { key: "convenor_name", label: "CONVENOR (NAME)", required: true },
    { key: "convenor_number", label: "CONVENOR (NUMBER)", required: true },
    { key: "district_delegate_name", label: "DISTRICT DELEGATE (NAME)", required: false },
    { key: "district_delegate_number", label: "DISTRICT DELEGATE (NUMBER)", required: false },
    { key: "state_delegate_name", label: "STATE DELEGATE (NAME)", required: false },
    { key: "state_delegate_number", label: "STATE DELEGATE (NUMBER)", required: false },
    { key: "zone_team_member1_name", label: "ZONE TEAM MEMBER 1 (NAME)", required: false },
    { key: "zone_team_member1_number", label: "ZONE TEAM MEMBER 1 (NUMBER)", required: false },
    { key: "zone_team_member2_name", label: "ZONE TEAM MEMBER 2 (NAME)", required: false },
    { key: "zone_team_member2_number", label: "ZONE TEAM MEMBER 2 (NUMBER)", required: false },
    { key: "zone_team_member3_name", label: "ZONE TEAM MEMBER 3 (NAME)", required: false },
    { key: "zone_team_member3_number", label: "ZONE TEAM MEMBER 3 (NUMBER)", required: false },
];

export default {
    name: "ProfaceWingForm",
    components: { AlertModel },
    props: {
        embedded: { type: Boolean, default: false },
    },
    emits: ["submitted"],
    data() {
        const form = {};
        FIELDS.forEach((f) => { form[f.key] = ""; });
        return {
            loading: true,
            submitting: false,
            message: "",
            alert_type: "",
            alert_message: "",
            zoneId: null,
            zoneName: "",
            canSubmitFromApi: false,
            hasSubmitted: false,
            fields: FIELDS,
            form,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        canSubmit() {
            return this.canSubmitFromApi;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.zoneId = parseInt(this.$route.params.id) || this.currentUser.zone_id;
        this.loadData();
    },
    watch: {
        "$route.params.id"(id) {
            this.zoneId = parseInt(id) || this.currentUser.zone_id;
            this.loadData();
        },
    },
    methods: {
        loadData() {
            this.loading = true;
            UserService.authGetRequest(`proface-wing/${this.zoneId}`).then((res) => {
                this.loading = false;
                if (res.data.status === "success") {
                    const data = res.data.data;
                    this.zoneName = data.zone?.name || "";
                    this.canSubmitFromApi = !!data.can_submit;
                    if (data.wing) {
                        this.hasSubmitted = true;
                        this.fields.forEach((f) => {
                            if (data.wing[f.key] !== null && data.wing[f.key] !== undefined) {
                                this.form[f.key] = data.wing[f.key];
                            }
                        });
                    }
                }
            }).catch((err) => {
                this.loading = false;
                this.message = err.response?.data?.message || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല";
            });
        },
        submitForm() {
            if (this.submitting) return;
            this.message = "";
            this.submitting = true;
            const payload = { zone_id: this.zoneId, ...this.form };
            UserService.authPostRequest("proface-wing", payload).then((res) => {
                this.submitting = false;
                if (res.data.status === "success") {
                    this.hasSubmitted = true;
                    this.alert_type = "Success";
                    this.alert_message = res.data.message;
                    this.$refs.alert_model.openModel();
                    this.$emit("submitted");
                } else {
                    this.message = res.data.message || "സമർപ്പിക്കാൻ കഴിഞ്ഞില്ല";
                }
            }).catch((err) => {
                this.submitting = false;
                this.message = err.response?.data?.message || "സമർപ്പിക്കാൻ കഴിഞ്ഞില്ല";
            });
        },
    },
};
</script>

<style scoped>
.custom-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a418c;
}
</style>
